module.exports = __webpack_public_path__ + "img/water_level_high.f8ebd95e.svg";